export const ctaTypes = {
  SIGN_IN: "SIGN_IN",
  SIGN_UP: "SIGN_UP",
};

export const errorTypes = {
  AUTHENTICATED_USER_RESTRICTED_CONTENT:
    "AUTHENTICATED_USER_RESTRICTED_CONTENT",
  UNAUTHENTICATED_USER_FREE_CONTENT: "UNAUTHENTICATED_USER_FREE_CONTENT",
  UNAUTHENTICATED_USER_RESTRICTED_CONTENT:
    "UNAUTHENTICATED_USER_RESTRICTED_CONTENT",
  NON_STUDENT_USER_RESTRICTED_CONTENT: "NON_STUDENT_USER_RESTRICTED_CONTENT",
  STUDENT_USER_RESTRICTED_CONTENT: "STUDENT_USER_RESTRICTED_CONTENT",
  STUDENT_USER_UNLICENSED_CONTENT: "STUDENT_USER_UNLICENSED_CONTENT",
  AUTHENTICATED_USER_DISTRICT_RESTRICTED_CONTENT:
    "AUTHENTICATED_USER_DISTRICT_RESTRICTED_CONTENT",
  GENERIC: "GENERIC",
};
